import api from './api';
import type {
  Ticket,
  TicketListResult,
  TicketStats,
  TicketCategory,
  TicketComment,
} from '../types/ticket.types';

export interface TicketListParams {
  status?: string;
  priority?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const ticketApi = {
  listTickets: (params: TicketListParams) =>
    api.get<TicketListResult>('/v1/tickets', { params }).then(r => r.data),

  getTicket: (id: string) =>
    api.get<Ticket>('/v1/tickets/' + id).then(r => r.data),

  createTicket: (data: {
    subject: string;
    description: string;
    priority?: string;
    site_id?: string;
    category_id?: string;
    source?: string;
  }) => api.post<Ticket>('/v1/tickets', data).then(r => r.data),

  addComment: (ticketId: string, data: { body: string }) =>
    api.post<TicketComment>('/v1/tickets/' + ticketId + '/comments', data).then(r => r.data),

  getStats: () =>
    api.get<TicketStats>('/v1/tickets/stats').then(r => r.data),

  getCategories: () =>
    api.get<TicketCategory[]>('/v1/tickets/categories').then(r => r.data),
};
